import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { cn, isEmpty } from '../../../utils';
import { mapProfile } from '../../../utils/printerProfile';
import { updateEntity } from '../actions';
import SelectionRadio from '../SelectionRadio';
import { makeSelectProperty } from '../selector';
import DocketPrinter from './DocketPrinter';
import StickerPrinter from './StickerPrinter';

const General = ({ selectedProfile, updateField }) => {
  const [isDocket, setIsDocket] = useState(
    selectedProfile?.sticker_printer_enabled,
  );

  useEffect(() => {
    if (isEmpty(selectedProfile)) return;

    setIsDocket(!selectedProfile?.sticker_printer_enabled);
  }, [selectedProfile]);

  const onDocketTypeClicked = isDocketPrinter => {
    if (selectedProfile.is_default) return;

    setIsDocket(isDocketPrinter);

    updateField({
      selectedProfile: mapProfile({
        ...selectedProfile,
        sticker_printer_enabled: !isDocketPrinter,
      }),
    });
  };

  const printerTypeEl = (
    <div className="flex flex-col gap-y-2">
      <div className="font-medium">Select Printer Type</div>
      <div className="flex w-1/2 gap-x-4">
        <div
          className={cn({
            'flex flex-1 gap-x-2 px-4 py-2 border rounded-lg cursor-pointer': true,
            'border-primary-light bg-primary-lighter': isDocket,
            'border-grey': !isDocket,
          })}
          role="presentation"
          onClick={() => onDocketTypeClicked(true)}
        >
          <SelectionRadio isSelected={isDocket} />
          Docket
        </div>
        <div
          className={cn({
            'flex flex-1 gap-x-2 px-4 py-2 border rounded-lg cursor-pointer': true,
            'border-primary-light bg-primary-lighter': !isDocket,
            'border-grey': isDocket,
            'bg-grey-lighter opacity-50 cursor-not-allowed text-grey-darker':
              selectedProfile.is_default,
          })}
          role="presentation"
          onClick={() => onDocketTypeClicked(false)}
        >
          <SelectionRadio isSelected={!isDocket} />
          Sticker
        </div>
      </div>
    </div>
  );

  const contentEl = (() => {
    if (!isDocket) {
      return <StickerPrinter />;
    }

    return <DocketPrinter />;
  })();

  return (
    <div className="w-full flex flex-col gap-y-4 p-4 bg-white rounded-lg border border-grey">
      {printerTypeEl}
      {contentEl}
    </div>
  );
};

General.propTypes = {
  selectedProfile: PropTypes.object,
  updateField: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  selectedProfile: makeSelectProperty('selectedProfile'),
});

const mapDispatchToProps = dispatch => ({
  updateField: payload => dispatch(updateEntity(payload)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(General);
